import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { isFieldUser, CREW_PATH } from '@/lib/crewRouting'

/**
 * Bare-root entry guard.
 *
 * Wraps ONLY the index route. A Field user who lands on `/` is sent to the
 * crew shell; everyone else gets the children (the dashboard).
 *
 * This used to add that it and the login redirect were the app's only two
 * redirects. The login page now also honours a destination captured by the
 * route guards (AR-2b L1, `lib/redirectTarget.ts`), so that count was wrong
 * as well as brittle; it is dropped rather than incremented. What still
 * holds is the part that matters: deliberate navigation to /jobs, /timesheet
 * or anywhere else always sticks, which is what keeps the
 * ⋯ → Full site escape hatch (it targets /jobs) from bouncing straight back.
 */
export function FieldRedirect({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  if (isFieldUser(user)) return <Navigate to={CREW_PATH} replace />
  return <>{children}</>
}
